export default __webpack_public_path__ + "static/gNews-a3ca20d48de3704de29b49de1e0f224d.png";